import { Notification } from './../../../models/notification';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LanguageService } from 'app/_services/language.service';
import { NotificationsCenterService } from 'app/_services/notifications-center.service';
import { LIST_FADE_ANIMATION } from '../../common/list.animation';

@Component({
  selector: 'fury-toolbar-notifications',
  templateUrl: './toolbar-notifications.component.html',
  styleUrls: ['./toolbar-notifications.component.scss'],
  animations: [...LIST_FADE_ANIMATION]
})
export class ToolbarNotificationsComponent implements OnInit {

  notifications: Notification[];
  isOpen: boolean;

  public unreadNotificationsNumber: number;

  constructor(public languageService: LanguageService, private notificationsCenterService: NotificationsCenterService) {
  }

  ngOnInit() {
    this.refreshNotifications();
  }

  public refreshNotifications(): void {
    this.notificationsCenterService.getNotifications().subscribe(list => {
      this.unreadNotificationsNumber = list.filter(x => !x.read).length;
      this.notifications = this.sortByDate(list);
    })
  }
  sortByDate(list) {
    list.sort((a,b) => {
      if(a.creationDate > b.creationDate){
        return -1;
      }else if (a.creationDate > b.creationDate){
        return 1;
      }else{
        return 0;
      }
    })
    return list;
  }

  markAsRead(notification: Notification) {
    if (notification.read) {
      return;
    }

    this.notificationsCenterService.markNotificationRead(notification).subscribe();

    notification.read = true;
    this.unreadNotificationsNumber--;

    // this.notifications = this.notifications.filter(x => x.idNotification !== notification.idNotification);
  }


  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onClickOutside() {
    this.isOpen = false;
  }

  markAllAsRead() {
    this.notifications.filter(x => !x.read).forEach(el => this.markAsRead(el));
  }
}
